import React, { useEffect, useState } from "react";
import { SectionWrapper } from "../../hoc";
import "./Parts.css";
import TextParts from "./TextParts";
import TableOfContents from "../TableOfContents/TableOfContents.tsx";
import TocMobile from "../ToCTelephone/TocTelephone.tsx";
import { RingLoader } from "react-spinners"; // Import the spinner component from react-spinners
import { scrollToId } from "../../utils/scrollToId";

const Parts = ({setDisplayNavBar}) => {
  const [loading, setLoading] = useState(true); // State variable to control loading
  const headingsData = [
    {
      level: 2,
      text: "New parts",
          id: "New parts",
    },
    {
      level: 2,
        text: "Used parts",
        id: "Used parts",
    }
  ];

  useEffect(() => {
    // Simulate a delay (remove this in your actual implementation)
    setTimeout(() => {
      setLoading(false); // Set loading to false after a delay
    }, 2000); // Simulated delay of 2 seconds

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setDisplayNavBar(!loading)
    if(!loading){
      scrollToId()
    }
  }, [loading, setDisplayNavBar])

  return (
    <div className="relative">
      {loading ? (<div className="spinner-container fixed h-screen w-screen bg-white z-10">
          <RingLoader color="#BA55D3" loading={loading} />{" "}
          <script>{document.body.style.overflow = 'hidden'}</script>
        </div>): <script>{document.body.style.overflow = 'auto'}</script>}
        <>
          <div className="top-page">
            <h1>Parts</h1>
          </div>

          <div
            className="grid grid-cols-12 gap-4"
            style={{ marginRight: "50px", marginLeft: "50px" }}
          >
            <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
              <div className="sticky top-4 scrollable">
                <TableOfContents headings={headingsData} />
              </div>
            </div>
            <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
              <React.StrictMode>
                <TextParts />
              </React.StrictMode>
            </main>
            <div
              className="md:hidden col-span-12 order-3 z-[8]"
              style={{
                position: "fixed",
                right: 0,
                left: 0,
                bottom: 0,
                width: "100%",
                marginRight: "200px",
                marginLeft: 0,
                background: "rgba(255, 255, 255, 1)",
                outline: "2px solid var(--purple-dark)",
              }}
            >
              <TocMobile headings={headingsData} />
            </div>
          </div>
        </>
    </div>
  );
};

export default SectionWrapper(Parts, "parts");
